export const LOADING = 0;
export const AWAITING = 1;
export const PLAYING = 2;
export const FINISHED = 3;
export const CANCELLED = 4;

export default { LOADING, AWAITING, PLAYING, FINISHED, CANCELLED }
